export const CONTACT_DATA = {
  instagramUrl: 'https://www.instagram.com/',
  twitterUrl: 'https://twitter.com/',
  youtubeUrl: 'https://www.youtube.com/',
  location: 'AZ complex bylane3 Mandari Rd Mumbai 1100867',
  phone: '+1800 287 256',
  email: 'Gogreendineservice@gmail.com'
};
export const OTHER_LINKS = [
  {
    id: 1,
    label: 'Privacy Policy',
    href: '/'
  },
  {
    id: 2,
    label: 'Terms & conditions',
    href: '/'
  },
  {
    id: 3,
    label: 'Blogs',
    href: '/'
  },
  {
    id: 4,
    label: 'Our team',
    href: '/'
  },
  {
    id: 5,
    label: 'Our kitchen',
    href: '/'
  }
];